import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { BadgeCheck } from 'lucide-react';
import { z } from 'zod';
import { Form } from '@/components/ui/form';
import { PCMP_ACK_REMARKS_MAX } from '../../constants/pcmpDisburseVerify.constants';
import { useConfirmPcmpDisbursement } from '../../hooks/useConfirmPcmpDisbursement';
import { PcmpCommentField } from '../PcmpMarketingActions/PcmpCommentField';
import { PcmpEditDialog } from '../PcmpProposalEdit/PcmpEditDialog';

const confirmFormSchema = z.object({
  remarks: z.string().trim().max(PCMP_ACK_REMARKS_MAX),
});

type ConfirmFormValues = z.infer<typeof confirmFormSchema>;

interface PcmpConfirmDisbursementDialogProps {
  proposalId: number;
  refNo: string;
  onClose: () => void;
}

/** Legacy ConfirmAccountsDisbursement (LDS-747); the remarks are optional. */
export function PcmpConfirmDisbursementDialog({
  proposalId,
  refNo,
  onClose,
}: PcmpConfirmDisbursementDialogProps) {
  const form = useForm<ConfirmFormValues>({
    resolver: zodResolver(confirmFormSchema),
    defaultValues: { remarks: '' },
  });
  const { mutate, isPending, error } = useConfirmPcmpDisbursement(proposalId, onClose);

  const onSubmit = form.handleSubmit((values) => mutate({ remarks: values.remarks || undefined }));

  return (
    <Form {...form}>
      <PcmpEditDialog
        open
        onOpenChange={(open) => !open && onClose()}
        title="Confirm Disbursement"
        description={refNo}
        icon={BadgeCheck}
        isDirty={form.formState.isDirty}
        isPending={isPending}
        error={error}
        onSubmit={(event) => void onSubmit(event)}
        submitLabel="Confirm"
        pendingLabel="Confirming..."
      >
        <p className="text-sm text-muted-foreground">
          Confirm that the teacher received the payment Accounts disbursed. A confirmation is final.
        </p>
        <PcmpCommentField
          control={form.control}
          name="remarks"
          label="Remarks"
          placeholder="Optional"
          max={PCMP_ACK_REMARKS_MAX}
        />
      </PcmpEditDialog>
    </Form>
  );
}
